import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../../Inbound/components/ImportModal/ImportModal.module.css";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: 408,
    xl: 408,
    md: 408,
  },
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  p: 4,
};

const RemoveSchedulerModal = ({
  open,
  setSelectedRemoveSchedulerType,
  noButtonClick,
  yesButtonClick,
  selecteRemoveSchedulerType,
}: any) => {
  return (
    <Modal
      open={open}
      onClose={() => setSelectedRemoveSchedulerType("")}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div>
          <div
            onClick={() => {
              setSelectedRemoveSchedulerType("");
            }}
            className={styles.closeModalButton}
          >
            <CloseIcon />
          </div>
          <div className={styles.modalTitle}>
            {selecteRemoveSchedulerType === "Remove only custom dates"
              ? "Remove only custom"
              : "Remove whole calender"}
          </div>
          <div className={styles.modalDes}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ fontWeight: 600 }}>
                {selecteRemoveSchedulerType === "Remove only custom dates"
                  ? "If you continue then the custom dates will be deleted"
                  : "If you continue then the whole schedule will be deleted"}
              </div>
            </div>
          </div>
          <div className={styles.buttonSection}>
            <button onClick={noButtonClick} className={styles.noButton}>
              Discard
            </button>
            <button
              onClick={yesButtonClick}
              style={{
                background: "#11c89b",
                boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                borderRadius: "4px",
                padding: "10px 18px",
                gap: "8px",
                width: "100%",
                color: " #ffffff",
                border: "0",
                cursor: "pointer",
              }}
            >
              Continue
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default RemoveSchedulerModal;
